import { RegionShared } from "@1games-ru/region-shared";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider";

export default class CharacterMpProvider {
  public static async getEstateCapacity(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.GetCharacterEstateCapacityResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetCharacterEstateCapacityRequest,
      typeof RegionShared.Backend.Responses.GetCharacterEstateCapacityResponse
    >(RegionShared.Backend.Events.Character.GetCharacterEstateCapacity, {});
  }

  public static async estateCapacityUpgrade(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.CharacterEstateCapacityUpgradeResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.CharacterEstateCapacityUpgradeRequest,
      typeof RegionShared.Backend.Responses.CharacterEstateCapacityUpgradeResponse
    >(RegionShared.Backend.Events.Character.CharacterEstateCapacityUpgrade, {});
  }
}
